import { useMemo } from 'react'

import type { SalesChannelType } from '@/api/admin-sales-channels-types'
import { useListSalesChannelTypes } from '@/api/react-query'
import { useI18n } from '@/i18n/i18n-react'

export const useSalesChannelTypeFieldOptions = () => {
	const { L } = useI18n()
	const salesChannelTypes = useListSalesChannelTypes()

	return useMemo(
		() => [
			{ value: '', label: L.Settings.SalesChannels.SalesChannelTypeNone() },
			...(salesChannelTypes.data?.map(type => ({
				value: type.uuid,
				label: type.name
			})) ?? [])
		],
		[L, salesChannelTypes.data]
	)
}

export const formatSalesChannelTypeLabel = (
	type: Pick<SalesChannelType, 'name' | 'fulfillmentProvider'> | undefined,
	L: ReturnType<typeof useI18n>['L']
) => {
	if (!type) return L.Settings.SalesChannels.SalesChannelTypeNone()
	if (type.fulfillmentProvider) {
		return `${type.name} (${L.Enum.FulfillmentProvider(type.fulfillmentProvider)})`
	}
	return type.name
}
